import React from 'react';
import { Box, TextField, FormControlLabel, Checkbox, Autocomplete, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import { medicalDeviceData } from '../../../data/medicalDeviceData';

const NewDeviceFields = ({
    addDevice,
    setAddDevice,
    seriNumarasi,
    setSeriNumarasi,
    marka,
    setMarka,
    model,
    setModel,
    cihazSinifi,
    setCihazSinifi,
    isSgk,
    setIsSgk,
    zimmetTarihi,
    setZimmetTarihi,
    faturaNo,
    setFaturaNo,
    verilisTarihi,
    setVerilisTarihi,
    garantiBaslangic,
    setGarantiBaslangic,
    garantiBitis,
    setGarantiBitis,
    periyodikBakimTarihi,
    setPeriyodikBakimTarihi,
    brandsFromDb
}) => {
    return (
        <Box>
            <FormControlLabel
                control={<Checkbox checked={addDevice} onChange={(e) => setAddDevice(e.target.checked)} />}
                label="Bu Müşteriye Cihaz Ekle"
            />
            {addDevice && (
                <Box sx={{ pl: 2, pt: 2, borderTop: '1px dashed #ccc', display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    <TextField
                        label="Seri Numarası"
                        value={seriNumarasi}
                        onChange={(e) => setSeriNumarasi(e.target.value)}
                        required
                        fullWidth
                    />

                    {/* Marka Selection */}
                    <Autocomplete
                        freeSolo
                        options={[...new Set([...brandsFromDb.map(b => b.name), ...Object.keys(medicalDeviceData)])].sort()}
                        value={marka}
                        onChange={(event, newValue) => { setMarka(newValue); setModel(''); }}
                        renderInput={(params) => <TextField {...params} label="Marka" required fullWidth />}
                    />

                    {/* Model Selection */}
                    <Autocomplete
                        freeSolo
                        options={(() => {
                            const dbBrand = brandsFromDb.find(b => b.name === marka);
                            const dbModels = dbBrand?.models?.map(m => m.model) || [];
                            const staticModels = medicalDeviceData[marka]?.map(m => m.model) || [];
                            return [...new Set([...dbModels, ...staticModels])].sort();
                        })()}
                        value={model}
                        onChange={(event, newValue) => setModel(newValue)}
                        disabled={!marka}
                        renderInput={(params) => <TextField {...params} label="Model" fullWidth />}
                    />

                    {/* Cihaz Sınıfı Selection */}
                    <FormControl fullWidth>
                        <InputLabel>Cihaz Sınıfı</InputLabel>
                        <Select
                            value={cihazSinifi}
                            label="Cihaz Sınıfı"
                            onChange={(e) => setCihazSinifi(e.target.value)}
                        >
                            <MenuItem value="Oksijen Konsantratörü">Oksijen Konsantratörü</MenuItem>
                            <MenuItem value="Ventilatör">Ventilatör</MenuItem>
                            <MenuItem value="Cpap">Cpap</MenuItem>
                            <MenuItem value="Auto Cpap">Auto Cpap</MenuItem>
                            <MenuItem value="Bpap">Bpap</MenuItem>
                            <MenuItem value="Bpap ST">Bpap ST</MenuItem>
                            <MenuItem value="Avaps">Avaps</MenuItem>
                            <MenuItem value="ASV">ASV</MenuItem>
                            <MenuItem value="Diğer">Diğer</MenuItem>
                        </Select>
                    </FormControl>

                    {/* SGK Zimmet Durumu */}
                    <Box sx={{ p: 2, border: '1px solid #ff9800', borderRadius: 1, mt: 2, backgroundColor: '#fff3e0' }}>
                        <Typography variant="subtitle2" color="warning.dark" gutterBottom>SGK Durumu</Typography>
                        <FormControlLabel
                            control={<Checkbox checked={isSgk} onChange={(e) => setIsSgk(e.target.checked)} color="warning" />}
                            label="Bu cihaz SGK zimmetli mi?"
                        />
                        {isSgk && (
                            <TextField
                                label="Zimmet Tarihi"
                                type="date"
                                value={zimmetTarihi}
                                onChange={(e) => setZimmetTarihi(e.target.value)}
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ mt: 2 }}
                            />
                        )}
                    </Box>

                    {/* Tarih ve Fatura Bilgileri */}
                    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2 }}>
                        <TextField
                            label="Fatura No"
                            value={faturaNo}
                            onChange={(e) => setFaturaNo(e.target.value)}
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Veriliş Tarihi"
                            type="date"
                            value={verilisTarihi}
                            onChange={(e) => setVerilisTarihi(e.target.value)}
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Garanti Başlangıç"
                            type="date"
                            value={garantiBaslangic}
                            onChange={(e) => setGarantiBaslangic(e.target.value)}
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Garanti Bitiş"
                            type="date"
                            value={garantiBitis}
                            onChange={(e) => setGarantiBitis(e.target.value)}
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Periyodik Bakım Tarihi"
                            type="date"
                            value={periyodikBakimTarihi}
                            onChange={(e) => setPeriyodikBakimTarihi(e.target.value)}
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default NewDeviceFields;
